import { createContext, PropsWithChildren, useCallback, useContext, useState } from "react";
import { useIncognitoProtection } from "./useIncognitoProtection";



export enum RouterState {
    /** Probíhá připojení */
    LOADING = 0,
    /** Zobrazení nějaké custom zprávy */
    MESSAGE = 1,
    /** Interaktivní editor pro submit */
    EDITOR = 2,
    /** Výběr barvy */
    COLOR = 3,
    /** Color picker */
    COMMENT = 4,
    /** Zobrazení pending stavu, který nelze přerušit */
    STAGE = 5,
    /** Zobrazení stránky about */
    ABOUT = 6
}

type RouterContextType = {
    state: RouterState;
    routerMessage?: string;
    showLoading: (message?: string) => void;
    showMessage: (message: string) => void;
    showStage: () => void;
    showAbout: () => void;
    showEditor: () => void;
    showColor: () => void;
    showComment: () => void;
    isIncognito: boolean;
    mayConnect: boolean;
}

const RouterContext = createContext<RouterContextType>({} as RouterContextType);

export const RouterContextProvider: React.FC<PropsWithChildren> = ({ children }) => {


    const [
        state,
        setState
    ] = useState<RouterState>(RouterState.LOADING);


    const [
        routerMessage,
        setRouterMessage
    ] = useState<string | undefined>(undefined);


    const showLoading = useCallback( (
        message?: string
    ) => {
        setState( RouterState.LOADING );
        setRouterMessage( message );
    }, [ setRouterMessage, setState ] );


    const showMessage = useCallback( (
        message: string
    ) => {
        setState( RouterState.MESSAGE );
        setRouterMessage( message );
    }, [ setState, setRouterMessage ] );

    const showStage = useCallback( () => {
        setState( RouterState.STAGE );
        setRouterMessage( undefined );
    }, [ setState, setRouterMessage ] );

    const showAbout = useCallback( () => {
        setState( RouterState.ABOUT );
        setRouterMessage( undefined );
    }, [ setState, setRouterMessage ] );

    const showEditor = useCallback( () => {
        setState( RouterState.EDITOR );
        setRouterMessage( undefined );
    }, [ setState, setRouterMessage ] );


    const showColor = useCallback( () => {
        setState( RouterState.COLOR );
        setRouterMessage( undefined );
    }, [ setState, setRouterMessage ] );

    const showComment = useCallback( () => {
        setState( RouterState.COMMENT );
        setRouterMessage( undefined );
    }, [ setState, setRouterMessage ] );

    const {
        isIncognito,
        mayConnect
    } = useIncognitoProtection();


    const value: RouterContextType = {
        state,
        routerMessage,
        showLoading,
        showMessage,
        showStage,
        showAbout,
        showEditor,
        showColor,
        showComment,
        isIncognito,
        mayConnect
    }

    return <RouterContext.Provider value={value}>
        {children}
    </RouterContext.Provider>

}



export const useRouterContext = () => {

    return useContext( RouterContext );

}